<template>
  <div
    class="rr-training-activity"
    :class="classes"
  >
    <template v-if="summary">
      <Metric
        :icon="activityIcon"
        :value="value"
        :units="units"
        :subtitle="activityName"
        :disabled="disabled"
        :soon="soon"
      ></Metric>
    </template>
    <template v-else>
      <div class="rr-training-activity__offset" ref="trigger"></div>
      <div class="rr-training-activity__container" ref="container">
        <div
          ref="header"
          class="rr-training-activity__header"
          @click.prevent="toggle"
        >
          <div class="rr-training-activity__icon" v-if="icon">
            <Icon :name="icon" size="l"></Icon>
          </div>
          <div class="rr-training-activity__info">
            <div class="rr-training-activity__name">{{ name }}</div>
            <div
              class="rr-training-activity__details"
              v-if="details"
              v-html="details"
            ></div>
          </div>
          <button
            class="rr-training-activity__caret"
            v-if="collapsable"
            type="button"
          >
            <Icon :name="isCollapsed ? 'down' : 'up'" size="xl"></Icon>
          </button>
        </div>
        <div class="rr-training-activity__body" v-show="!isCollapsed">
          <div class="rr-training-activity__body-wrap">
            <slot :collapsed="isCollapsed"></slot>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import activities from '@rr-component-library/common/src/js/activity-types';
import Icon from '@rr-component-library/icon/src/main';
import Metric from '@rr-component-library/metric/src/main';

export default {
  name: 'TrainingActivity',
  designVersion: '1.1.1',
  components: {
    Icon,
    Metric,
  },
  props: {
    summary: {
      type: Boolean,
      default: false,
    },
    activity: {
      type: String,
      default: 'running',
      validator(value) {
        return ['running', 'walking', 'cycling', 'skiing', 'swimming'].indexOf(value) !== -1;
      },
    },
    icon: String,
    value: String,
    units: String,
    name: String,
    details: {
      type: String,
    },
    collapsable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    soon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: this.collapsable,
    };
  },
  computed: {
    isCollapsed() {
      return this.collapsable && this.collapsed;
    },
    classes() {
      return [
        this.activity && `rr-training-activity_${this.activity}`,
        this.collapsable && 'rr-training-activity_collapsable',
        this.isCollapsed && 'rr-training-activity_collapsed',
        this.summary ? 'rr-training-activity_summary' : 'rr-training-activity_training',
      ];
    },
    activityData() {
      return this.activity && activities[this.activity];
    },
    activityIcon() {
      return this.icon || (this.activityData && this.activityData.icon);
    },
    activityName() {
      return this.name || (this.activityData && this.activityData.name);
    },
  },
  methods: {
    toggle() {
      if (!this.collapsable) {
        return;
      }
      this.collapsed = !this.collapsed;
      this.$emit('toggle', this.isCollapsed);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./TrainingActivity";
</style>
